import axios from 'axios'
import router from '../../router'

const state = {
  groups: []
}

const getters = {
  getSysadminGroups (state) {
    return state.groups
  }
}

const mutations = {
  setSysadminGroups (state, payload) {
    state.groups = payload
  }
}
const actions = {
  apiSysadminGroups (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.method === 'POST') {
        axios.post('/api/sysadmin/groups', payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminGroups', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else if (payload.method === 'PATCH') {
        axios.patch('/api/sysadmin/groups/' + payload.id, payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminGroups', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else { // GET method
        axios.get('/api/sysadmin/groups')
          .then((response) => {
            context.commit('setSysadminGroups', response.data)
            context.dispatch('apiCommonsStatus')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/admingroup.js